//@flow

import React from 'react';
import { Field } from 'formik';

type Option = {
  value: string,
  title: string,
};

type Props = {
  name: string,
  options: Array<Option>,
  className: string,
};

export default function CustomSelect(props: Props) {
  const { options, name, className } = props;

  return (
    <Field name={name} component="select" className={className}>
      {options.map(({ value, title }: Option) => {
        return (
          <option value={value} key={title}>
            {title}
          </option>
        );
      })}
    </Field>
  );
}

CustomSelect.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/components/Inputs/CustomSelect.js